import gsap from 'gsap';
import { Sprite } from 'three';
import { ref, watchEffect } from 'vue';

import { usePane } from '@resn/gozer-vue';

import {
    createShineFlareSpriteMaterial,
    syncShineFlareMaterialUniforms,
} from './shine-flare-sprite';

export const useFlare = ({ name = 'Flare', scale = 0.5 } = {}) => {
    const uFlareRayWidth = ref(0.0175);
    const uFlareRayFade = ref(0.2);
    const uFlareScale = ref(scale);
    const uFlareRayIntensity = ref(1);
    const uFlareAlpha = ref(0);
    const uFlareRotation = ref(0);

    const material = createShineFlareSpriteMaterial({
        uFlareRayWidth: uFlareRayWidth.value,
        uFlareRayFade: uFlareRayFade.value,
        uFlareRayIntensity: uFlareRayIntensity.value,
        uFlareAlpha: uFlareAlpha.value,
        uFlareRotation: uFlareRotation.value,
    });

    const mesh = new Sprite(material);
    mesh.scale.setScalar(uFlareScale.value);
    // mesh.renderOrder = 2;

    const showFlare = () => {
        const tl = gsap.timeline();

        tl.fromTo(uFlareAlpha, { value: 0 }, { value: 1, duration: 0.4, ease: 'sine.out' }, 0);
        tl.fromTo(uFlareRotation, { value: 0 }, { value: 6.28, duration: 2, ease: 'linear' }, 0);
        tl.to(uFlareAlpha, { value: 0, duration: 0.4, ease: 'sine.out' }, 0.6);

        return tl;
    };

    watchEffect(() => {
        if (!material.uniforms) return;
        syncShineFlareMaterialUniforms(material, {
            uFlareRayWidth: uFlareRayWidth.value,
            uFlareRayFade: uFlareRayFade.value,
            uFlareRayIntensity: uFlareRayIntensity.value,
            uFlareAlpha: uFlareAlpha.value,
            uFlareRotation: uFlareRotation.value,
        });
        mesh.scale.setScalar(uFlareScale.value);
    });

    const paneOptions = [
        {
            name: 'uFlareRayWidth',
            value: uFlareRayWidth,
            options: { min: 0.0001, max: 0.1, step: 0.0001 },
        },
        {
            name: 'uFlareRayFade',
            value: uFlareRayFade,
            options: { min: 0.01, max: 2, step: 0.01 },
        },
        {
            name: 'uFlareScale',
            value: uFlareScale,
            options: { min: 0.01, max: 2, step: 0.01 },
        },
        {
            name: 'uFlareRayIntensity',
            value: uFlareRayIntensity,
            options: { min: 0, max: 5, step: 0.01 },
        },
        {
            name: 'uFlareAlpha',
            value: uFlareAlpha,
            options: { min: 0, max: 1, step: 0.01 },
        },
    ];

    // usePane(paneOptions, { title: name });

    const refs = {
        uFlareRayWidth,
        uFlareRayFade,
        uFlareScale,
        uFlareRayIntensity,
        uFlareAlpha,
        uFlareRotation,
    };

    return { mesh, material, refs, showFlare };
};
